import React, { useState } from 'react';
import { useGetTablesStatistics } from '../hooks/statisticsHooks';
import { useTournamentStore } from '../../../service/useTournamentStore';
import DailyTimeLine from '../components/DailyTimeLine';
import MatchCard from '../components/MatchCard';
import type { MatchSlot } from '@iziping/common';
import styles from './TableStatistics.module.css';

const TableStatistics: React.FC = () => {
    const { selectedTournament } = useTournamentStore();
    const {
        data: tables,
        isLoading,
        isError,
    } = useGetTablesStatistics({
        tournamentId: Number(selectedTournament?.id),
    });

    const [selectedSlot, setSelectedSlot] = useState<{ slot: MatchSlot; rect: DOMRect } | null>(null);

    const tournamentDate = tables?.begin ? new Date(tables.begin) : new Date();

    const startHour = tables?.begin ? Math.max(0, new Date(tables.begin).getHours() - 1) : 8;
    const endHour = (() => {
        if (!tables?.end || !tables?.begin) return 24;
        const begin = new Date(tables.begin);
        const end = new Date(tables.end);
        const crossesMidnight = end.getDate() !== begin.getDate();
        const rawEndHour = crossesMidnight ? 24 + end.getHours() : end.getHours();
        return rawEndHour + 1;
    })();

    const formattedDate = tournamentDate.toLocaleDateString('fr-FR', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    return (
        <div>
            <div className={styles.header}>
                <div className={styles.titleBlock}>
                    <h2 className={styles.title}>Occupation des tables</h2>
                    {selectedTournament && (
                        <p className={styles.subtitle}>
                            {selectedTournament.name} · {formattedDate}
                        </p>
                    )}
                </div>
                <div className={styles.legend}>
                    <span className={`${styles.legendItem} ${styles.legendUpcoming}`}>À venir</span>
                    <span className={`${styles.legendItem} ${styles.legendActive}`}>En cours</span>
                    <span className={`${styles.legendItem} ${styles.legendFinished}`}>Terminé</span>
                </div>
            </div>

            {isLoading ? (
                <p>Chargement des stats tables...</p>
            ) : isError ? (
                <p>Une erreur est survenue lors du chargement des stats.</p>
            ) : (
                <DailyTimeLine
                    tournamentTableSlots={tables}
                    startHour={startHour}
                    endHour={endHour}
                    date={tournamentDate}
                    onSlotClick={(slot, rect) => setSelectedSlot({ slot, rect })}
                />
            )}

            {selectedSlot && (
                <MatchCard
                    slot={selectedSlot.slot}
                    anchorRect={selectedSlot.rect}
                    onClose={() => setSelectedSlot(null)}
                />
            )}
        </div>
    );
};

export default TableStatistics;
